import { render, staticRenderFns } from "./biddingRelationshipList.vue?vue&type=template&id=ff964140&scoped=true"
import script from "./biddingRelationshipList.vue?vue&type=script&lang=js"
export * from "./biddingRelationshipList.vue?vue&type=script&lang=js"
import style0 from "./biddingRelationshipList.vue?vue&type=style&index=0&id=ff964140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff964140",
  null
  
)

export default component.exports